export default "/images/logo.svg?a0143fa8ed5f53bf9ab4425b9a374176";